
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Solving Trust Issues with Contract Based Testing`}</h1>
    <p>{`@kjendrzyca / skutecznyprogramista.pl`}</p>
    <hr></hr>
    <h2>{`Agenda`}</h2>
    <ul>
      <li parentName="ul">{`What is Contract Testing?`}</li>
      <li parentName="ul">{`Trust issues`}</li>
      <li parentName="ul">{`Example 1`}</li>
      <li parentName="ul">{`Example 2`}</li>
      <li parentName="ul">{`Example 3`}</li>
      <li parentName="ul">{`Q&A`}</li>
    </ul>
    <hr></hr>
    <h2>{`What is Contract Testing?`}</h2>
    <ul>
      <li parentName="ul">{`Scaling teams / External teams`}</li>
      <li parentName="ul">{`Large-scale manual system test (like microservices)`}</li>
      <li parentName="ul">{`Sticking to the interface`}</li>
    </ul>
    <hr></hr>
    <h2>{`Trust issues`}</h2>
    <ul>
      <li parentName="ul">{`Communication / Knowledge (how we use the API)`}</li>
      <li parentName="ul">{`Lack of skill`}</li>
      <li parentName="ul">{`Accidental changes`}</li>
      <li parentName="ul">{`Timezones`}</li>
    </ul>
    <hr></hr>
    <h2>{`Example 1 - DB`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`big static database`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`no chance to run it locally`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`different timezone`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`no migrations`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`a lot of work`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`in the morning - the app doesn't work 🤷‍♂️`}</p>
      </li>
    </ul>
    <hr></hr>
    <h3>{`Good practices`}</h3>
    <ul>
      <li parentName="ul">{`avoid big snapshots`}</li>
      <li parentName="ul">{`communicate a lot`}</li>
    </ul>
    <hr></hr>
    <h2>{`Example 2 - API`}</h2>
    <ul>
      <li parentName="ul">{`similar as with the db example`}</li>
    </ul>
    <hr></hr>
    <h2>{`Example 3 - Pact`}</h2>
    <ul>
      <li parentName="ul">{`Consumer-Driven Contract tests`}</li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "https://pactflow.io/how-pact-works"
      }}>{`https://pactflow.io/how-pact-works`}</a></p>
    <hr></hr>
    <h3>{`Good practices`}</h3>
    <ul>
      <li parentName="ul">{`check only what's needed`}</li>
      <li parentName="ul">{`don't use when you control the whole thing`}</li>
    </ul>
    <hr></hr>
    <h2>{`Q&A`}</h2>
    <hr></hr>
    <h2>{`Links`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/pact-foundation/pact-js"
        }}>{`Pact JS`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/kjendrzyca/contract-testing-example"
        }}>{`https://github.com/kjendrzyca/contract-testing-example`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://jestjs.io/docs/en/snapshot-testing"
        }}>{`https://jestjs.io/docs/en/snapshot-testing`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/public-apis/public-apis"
        }}>{`https://github.com/public-apis/public-apis`}</a></li>
      <li parentName="ul">{`Jest snapshot language support (VSCode)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://hub.docker.com/r/pactfoundation/pact-broker"
        }}>{`Pact Broker for publishing contracts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://pactflow.io/"
        }}>{`https://pactflow.io/`}</a></li>
      <li parentName="ul">{`You can use JSON Schema or TypeScript instead of snapshots, but I haven't tested that myself, so not recommending any links (fell free to make a PR)`}</li>
    </ul>
    <hr></hr>
    <p>{`👋`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;